import {
  LocalizationContextBuilder,
} from '@amzn/arb-tools';
import translations from './i18n/translations';
import arbManifest from './i18n/translations/arbManifest';
import { DEFAULT_LOCALE } from './constants';

const LOCALIZATION_CONTEXTS = new Map();

export function getLocalizationContext(locale) {
  let lc = LOCALIZATION_CONTEXTS.get(locale);

  if (!lc) {
      lc = new LocalizationContextBuilder()
          .withLocale(locale)
          .withDefaultLocale(DEFAULT_LOCALE)
          .build();

      LOCALIZATION_CONTEXTS.set(locale, lc);
  }

  return lc;
}

export function t(
  bundle,
  stringId,
  args,
) {
  if (!bundle || !stringId) {
      return undefined;
  }

  if (!args) {
      return bundle.getMessage(stringId);
  }

  return bundle.formatMessage(stringId, args);
}

export function resolveBundleUrlWithFallbacks(
  resourcePackPath,
  locale,
  bundle,
) {
  if (resourcePackPath && translations[resourcePackPath]) {
      return translations[resourcePackPath];
  }

  if (!resourcePackPath && arbManifest.endpointMap?.[locale]?.[bundle]) {
      return translations[arbManifest.endpointMap[locale][bundle]];
  }

  if (arbManifest.endpointMap?.[DEFAULT_LOCALE]?.[bundle]) {
      return translations[arbManifest.endpointMap[DEFAULT_LOCALE][bundle]];
  }
}
